module.exports = __webpack_public_path__ + "img/Ken_McGovern.d7320d2.png";